"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMC_APP_CONTAINER_ID = void 0;
exports.PMC_APP_CONTAINER_ID = 'pmc-app';
//# sourceMappingURL=types.js.map